import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * DEPRECATED shim — `/overview` was renamed to `/case-details` (D14). Redirects
 * old deep links (bookmarks, emailed links, Sentry breadcrumbs) so they keep
 * working. Preserves search params (enrichKey / enrichValue / logId).
 */
export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/overview',
)({
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: '/air/case-management/$id/case-details',
			params: { id: params.id },
			search,
			replace: true,
		})
	},
})
